import {
  getRequest,
  getRequestWithParams,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

const getOrderById = (orderId) => {
  return getRequest(`orders/${orderId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getOrdersWithParams = (limit,page,status_id,sort) => {
  return getRequest(`orders?limit=${limit}&page=${page}&status_id=${status_id}&sort=${sort}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getOrderStatusesWithCount = () => {
  return getRequest(`orders/count`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const orderService = {
 getOrderById,
 getOrdersWithParams,
 getOrderStatusesWithCount
};
